import React, { useContext, useEffect, useState } from "react";
import { useMobileDimensions, useToken, useWindowDimensions } from '@app/hooks';
import { CrossModalDescriptionBox, CrossModalWrapper } from "./styles";
import { Text, View } from "@/styles/reactnative";
import { useTranslation } from "react-i18next";
import { COLORS } from "@app/constants";
import CrossSliderBar from "./CrossSliderBar";
import CrossModalHeader from "./CrossModalHeader";
import CrossModalFooter from "./CrossModalFooter";
import { CButton } from "../../../../../../components/Common";
import useTradeStore from "../../../../../../hooks/trade/tradeStore";
import { useTradeSetting } from "../../../../../../hooks/trade/tradeSetting";
import { ThemeContext } from '@/theme/ThemeProvider';
import { useTradePosition } from "@/app/hooks/trade/tradePosition";
import API from '@utils/api.ts';

const CrossModal = ({ setShowModal }) => {
  const { borderColor, textw } = useContext(ThemeContext).theme.COLORS;
  const { data: token } = useToken();
  const { t } = useTranslation();
  const { width, height } = useWindowDimensions();
  const wSize =
    width < 772
      ? width / 1.1
      : width < 1400
        ? width < 900
          ? width / 2
          : width / 3
        : width / 4;

  const CROSS = "cross";
  const ISO = "iso";
  const tabs = [CROSS, ISO];

  const { data: tradeStore, mutate: mutateTradeStore } = useTradeStore();
  const { data: tradeSetting, mutate: mutateTradeSetting } = useTradeSetting(tradeStore.ep_id);

  const [tab, setTab] = useState(tradeSetting?.cross_iso === "C" ? CROSS : ISO);

  const [leverage, setLeverage] = useState(tradeSetting?.leverage);
  // const [leverage, setLeverage] = useState(1)
  //
  // useEffect(() => {
  //   mutateTradeStore({ ...tradeStore, selectLeverage: leverage });
  // }, [leverage]);

  // const { data: positionList, mutate: mutatePosition } = useTradePosition();
  //
  // const [positionData, setPostionData] = useState<any>()
  //
  // useEffect(() => {
  //   if(positionList){
  //     setPostionData(positionList.find(pos => pos.exchange_pairs_id === tradeStore.ep_id));
  //   }
  // }, [positionList]);
  //
  //
  // const handleConfirm = async () => {
  //   try {
  //     // const position = positionList.find(pos => pos.exchange_pairs_id === tradeStore.ep_id);
  //
  //     if (!positionData) {
  //       mutateTradeSetting({ leverage, cross_iso: tab === CROSS ? "C" : "I"}, tradeStore.ep_id);
  //       setShowModal(false);
  //       return;
  //     }
  //
  //     // const hasLimitOrder = position.limit_market === 'L'
  //     // if (hasLimitOrder) {
  //     //   alert("지정가 미체결 주문이 있어 레버리지 또는 마진모드 변경이 불가능합니다.");
  //     //   return;
  //     // }
  //
  //     // const price = getPrice(ep_id) || position.price;
  //
  //     const originAmount = positionData?.amount * positionData?.leverage
  //
  //     console.log('originAmount', originAmount, originAmount / leverage)
  //
  //     const orderParams = {
  //       leverage,
  //       order_id: positionData?.orders[0]?.id,
  //       margin: (positionData?.price * originAmount) / leverage,
  //       amount: originAmount / leverage,
  //     };
  //
  //     const result = await API.put('/trade/order', '' + token, orderParams);
  //
  //     if (result?.result?.success) {
  //       mutateTradeSetting({ leverage, cross_iso: tab === CROSS ? "C" : "I" }, tradeStore.ep_id);
  //       mutatePosition();
  //       setShowModal(false)
  //     } else {
  //       alert(result?.result?.message || '레버리지 변경 실패');
  //     }
  //   } catch (err) {
  //     console.error('레버리지 변경 오류:', err);
  //     alert('레버리지 변경 실패');
  //   }
  // };
  

  return (
    <CrossModalWrapper style={{ width: wSize }}>
      <CrossModalHeader closeModal={() => setShowModal(false)} />
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {tabs?.map((item, index) => (
          <CButton
            key={index.toString()}
            title={item && t(item)}
            onClick={() => setTab(item)}
            style={{
              background: item === tab ? COLORS.primary : "transparent",
              border: item !== tab ? `1px solid ${borderColor}` : "none",
              height: 34,
              width: "48%",
              justifyContent: "center",
              alignItems: "center",
              color: item === tab ? COLORS.white : textw,
              borderRadius: 4,
              cursor: "pointer",
            }}
          />
        ))}
      </View>

      <View style={{ width: "100%", marginTop: 20 }}>
        <CrossSliderBar
          leverage={leverage}
          setLeverage={setLeverage}
          maxLeverage={tradeStore.max_leverage}
        />
        {/* {leverage > 21 ? (
          <Text
            style={{
              marginTop: 25,
              color: '#F87943',
              fontSize: 12,
              lineHeight: '14px',
              fontWeight: '500'
            }}
          >
            {t("crossLeverageDangerText")}
          </Text>
        ) : null} */}
        <CrossModalDescriptionBox
          style={{
            background: "transparent",
          }}
        >
          <Text size={12}>
            {tab === CROSS
              ? t("crossModalDescription")
              : t("isoModalDescription")}
          </Text>
        </CrossModalDescriptionBox>

        <CrossModalFooter
          ep_id={tradeStore.ep_id}
          cross_iso={tab === CROSS ? "C" : "I"}
          leverage={leverage}
          closeModal={() => setShowModal(false)}
          // handleConfirm={() => handleConfirm()}
        />
      </View>
    </CrossModalWrapper>
  );
};

export default React.memo(CrossModal);
